import Preferences from "./Preferences"
const SalesPreference = () => {
    return (
        <Preferences roundoffTransactionType="Sales"/>
    )
}

export default SalesPreference;